module.exports = __webpack_public_path__ + "img/npmjs.11fbe072.svg";